
import { Component, Vue } from 'vue-property-decorator'
import MallBrandService from '@/biz/service/Mall/MallBrandService'

@Component
export default class MallBrandIndex extends Vue {
  private MallBrandService = MallBrandService
}
